import React from 'react'
import { FLAG_URL } from '../../Config/config'
import { Img } from '../Image/Img'
import { FlagCon } from '../../Pages/Player/components/PlayerLinkBar/styles'

const COUNTRIES: { [key: string]: string } = {
  usa: 'USA',
  can: 'Canada',
  irq: 'Iroquois',
}

type FlagProps = {
  countryCode: string
  className?: string
}
export const CountryFlag: React.FC<React.PropsWithChildren<FlagProps>> = ({
  countryCode,
  className,
}) => {
  if (!countryCode) return null
  const cc = countryCode.trim().toLowerCase()
  const country = COUNTRIES[cc]
  if (!country) {
    return null
  }
  return (
    <FlagCon>
      <Img
        className={className || 'flag'}
        src={`${FLAG_URL}${cc}Flag.svg`}
        alt={`Country: ${country}`}
        key={`${country}Flag`}
      />
    </FlagCon>
  )
}
